// extracted by mini-css-extract-plugin
export default {"prefix":"PhoneNumberInput_prefix__3Mojp","phone":"PhoneNumberInput_phone__+3VIg"};